import { motion } from 'framer-motion';
import Header from '../components/global/header'
import Main from '../components/home/main'
import Footer from '../components/global/footer'

function IOS() {
  return (
    <>
      <Header />
      <section className="relative overflow-hidden py-12 lg:py-16">
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full blur-[100px] opacity-25 pointer-events-none" style={{ background: 'radial-gradient(ellipse at center, #0ea5e9 0%, #06b6d4 40%, transparent 70%)' }} />
        <div className="mx-auto max-w-4xl px-6 text-center relative">
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="glass-strong rounded-[28px] px-8 py-12 gradient-border">
            <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.14em] text-sky-300 font-medium"><span className="w-1.5 h-1.5 rounded-full bg-sky-400" /> iOS • iPHONE & IPAD</div>
            <h1 className="mt-3 text-[36px] lg:text-[44px] font-semibold tracking-[-0.03em] leading-[0.95] text-white">
              iOS Apps For <span className="bg-gradient-to-r from-sky-300 to-cyan-300 bg-clip-text text-transparent">Everyday Use</span>
              <br /><span className="text-white/60 text-[22px] lg:text-[28px]">Created by Draunt</span>
            </h1>
            <p className="text-[17px] leading-7 text-white/55 mt-4 max-w-2xl mx-auto">
              We develop apps to help you save time, boost productivity, and achieve more.
            </p>
            <p className="text-sm text-sky-300 font-medium mt-2">
              Tap any app below to download on iPhone/iPad.
            </p>
            <div className="mt-6 flex justify-center">
              <a href="#apps" className="rounded-full bg-white text-black font-medium px-7 h-[44px] inline-flex items-center hover:bg-white/90 transition">Browse Apps →</a>
            </div>
          </motion.div>
        </div>
      </section>

      <Main showHero={false} excludeCategories={['Veterans']} appsSectionTitle="All iOS Apps" />
      <Footer />
    </>
  );
}

export default IOS; 
